import React from "react";

const TaskOnsiteActionIcon = (props) => (
    <svg className={props.className} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "On Site"}</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.616 12.0304C4.29059 12.0304 4.12762 11.6523 4.3577 11.4311L12.2417 3.85284C12.3843 3.71572 12.6157 3.71572 12.7583 3.85284L20.6423 11.4311C20.8724 11.6523 20.7094 12.0304 20.384 12.0304H18.4403V19.8989C18.4403 20.0928 18.2767 20.25 18.075 20.25H6.925C6.72327 20.25 6.55973 20.0928 6.55973 19.8989V12.0304H4.616Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default TaskOnsiteActionIcon;
